export const CREATE = 1
export const EDIT = 2
export const PRINT = 7
export const DELETE = 4
export const CLAME = 0
export const APPROVE = 5
export const CANCEL = 6
export const PAYMENT = 8
export const APPROVE_PAY = 3
